<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2" v-if="isPaidBill">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <alert-box ref="alertBox" class="spacer-bottom-l" />

        <div class="z-title z-title--small spacer-bottom-l">
          Comprovante de pagamento
        </div>

        <payment-receipt :bill="bill" :course-name="currentBilling.course_name" :student-name="student.name" />
      </div>
    </div>
  </div>
</template>

<script>
import AlertBox from 'components/zilla/alert-box';
import Breadcrumb from 'components/breadcrumb';
import PaymentReceipt from 'components/payment-receipt';
import DashboardService from 'services/DashboardService';
import { mapState } from 'vuex';

export default {
  components: {
    AlertBox,
    Breadcrumb,
    PaymentReceipt,
  },
  data() {
    return {
      bill: {},
      originRoutename: 'panel',
      originRouteLabel: 'Quero Pago',
    };
  },
  computed: {
    ...mapState([
      'currentBilling',
      'student',
    ]),
    isPaidBill() {
      return this.bill.status === 'paid';
    },
  },
  methods: {
    loadReceiptData() {
      DashboardService.getBill(this.$route.params.billId)
        .then((data) => {
          this.bill = data;
          this.validateBill();
        })
        .catch((error) => {
          this.$refs.alertBox.show(
            'danger', 'Erro inesperado',
            'Não foi possível carregar o comprovante. Recarregue a página ou entre em contato com o Quero Pago.',
          );
          this.$rollbar.error(error);
        });
    },
    validateBill() {
      if (this.bill.status !== 'paid') {
        this.$router.push({ name: 'panel' });
      }
    },
  },
  mounted() {
    this.loadReceiptData();
    this.$tracker.logEvent('Viewed Receipt Page');
  },
};
</script>
